/**
 *
 * ParkingOperatorView
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';

function ParkingOperatorView({ dataTable, formDialog, viewName, viewStyles }) {
  return (
    <div style={viewStyles.root}>
      <Paper style={viewStyles.dataTable}>
        {
          React.cloneElement(dataTable, { viewName })
        }
      </Paper>
      { formDialog }
    </div>
  );
}

ParkingOperatorView.propTypes = {
  dataTable: PropTypes.node.isRequired,
  formDialog: PropTypes.node.isRequired,
  viewName: PropTypes.string.isRequired,
  viewStyles: PropTypes.object,
};

ParkingOperatorView.defaultProps = {
  viewStyles: {},
};

export default ParkingOperatorView;
